export default result => dispatch => {
    dispatch({
        type: "SET_AUTH_TOKENS",
        payload: result
    })
}